import { z } from "zod";

export const forensicRecoveryPathSchema = z.enum([
  "guardian_quorum",
  "key_quorum",
  "key_guardian",
  "key_offline_code",
]);

const eligiblePathSchema = z.discriminatedUnion("key", [
  z.object({ key: z.literal("guardian_quorum"), anotherPerson: z.literal(true), time: z.literal("immediate") }).strict(),
  z.object({ key: z.literal("key_quorum"), anotherPerson: z.literal(false), time: z.literal("24_hours") }).strict(),
  z.object({ key: z.literal("key_guardian"), anotherPerson: z.literal(true), time: z.literal("24_hours") }).strict(),
  z.object({ key: z.literal("key_offline_code"), anotherPerson: z.literal(false), time: z.literal("72_hours") }).strict(),
]);

const attemptSchema = z.object({
  attemptId: z.string().uuid(),
  path: forensicRecoveryPathSchema,
  status: z.enum(["collecting", "holding", "ready"]),
  holdUntil: z.string().datetime().nullable(),
  completedSteps: z.number().int().min(0).max(3),
  totalSteps: z.number().int().min(1).max(3),
  notificationState: z.enum(["not_required", "pending", "queued", "unavailable"]),
  steps: z.array(z.object({
    key: z.enum(["security_device", "trusted_person", "offline_code"]),
    state: z.enum(["complete", "current", "waiting"]),
  }).strict()).min(1).max(3),
  nextAction: z.enum([
    "passkey_1", "passkey_2", "offline_code", "retry_guardian",
    "wait_guardian", "wait_notifications", "wait_safety_hold", "change_path", "lift", "none",
  ]),
  canCancel: z.boolean(),
  canVeto: z.boolean(),
}).strict();

export const forensicRecoveryStatusSchema = z.object({
  pause: z.enum(["active", "inactive"]),
  eligiblePaths: z.array(eligiblePathSchema),
  attempt: attemptSchema.nullable(),
}).strict();

export type ForensicRecoveryPath = z.infer<typeof forensicRecoveryPathSchema>;
export type ForensicRecoveryStatus = z.infer<typeof forensicRecoveryStatusSchema>;
